<div class="container-fluid px-4">
    <div class="card mt-4">
        <div class="card-header">
            <h1 class=""style="font-size:22px" >レントゲン登録情報</h1>     
                <div class="card shadow-sm" style=" background-color: #F6F6F6;">
                    <div class="card-body">
                        <table class="table">
                            <tbody>
                                <tr>
                                <th style="width: 200px;">顧客名（個人ID）</th>
                                <td>{{ getCustomerDisplayName()}}</td>
                                </tr>
                                <tr>
                                <th style="width: 200px;">登録電話番号</th>
                                <td>{{ orderDetails[0]?.phone_number ?? customerData?.phone_number??'無し' }}</td>
                                </tr>
                                <tr>
                                <th style="width: 200px;">生年月日</th>
                                <td>
                                {{
                                    (orderDetails[0]?.date_of_birth |date:'yyyy年M月d日') ?? customerData?.date_of_birth 
                                   
                                }}
                                </td>                         

                                </tr>
                                <tr>
                                <th style="width: 200px;">メールアドレス</th>
                                <td>{{ orderDetails[0]?.email_address ?? customerData?.email_address?? '無し' }}</td>
                                </tr>
                                <tr>
                                <th style="width: 200px;">レントゲン対象</th>
                                <td>{{ orderDetails[0]?.profile_name ?? selectedUserName ?? '無し'}}</td>
                                </tr>
                                <tr>
                                <th style="width: 200px;">撮影医療機関名</th>
                                <td>{{ orderDetails[0]?.hospital_name ?? hospitalName ??'無し'}}</td>
                                </tr>
                                <tr>
                                <th style="width: 200px;">画像枚数</th>
                                <td>{{ fileList?.length ?? orderDetails[0]?.completed_files ??'無し'}}</td>
                                </tr>
                                <tr>
                                <th style="width: 200px;">データ登録日</th>                               
                                <td>
                                {{
                                    (orderDetails[0]?.created_at ? (orderDetails[0].created_at | date:'yyyy-MM-dd HH:mm:ss':'+0900') : (currentDate | date:'yyyy-MM-dd HH:mm:ss':'Asia/Tokyo'))
                                }}
                                </td>
                                <!-- <td>{{orderDetails[0].created_at | date:'yyyy-MM-dd HH:mm:ss':'+0900' }}</td> -->

                                </tr>
                            </tbody>
                            </table>

                    </div>
                </div>
                  <p class="mt-5"  style="font-size:14px">▼アップロードされたファイル </p>
          
        </div>
        <div class="table-responsive text-nowrap">
           
            <table id="completedOrderDataTable" class="table" width="100%" cellspacing="0" *ngIf="allFiles.length  > 0">
                <thead>
                    <tr>
                        <th>番号</th>
                        <th>ファイル名</th>
                        <th>ファイル形式</th>
                        <th>レントゲン種別</th>
                        <th>ファイル容量</th>
                       <th>画像</th>
                    </tr>
                </thead>
                <tbody class="table-border-bottom-0">                      
                    <tr *ngFor="let file of allFiles; let i = index">
                        <td>{{ i + 1 }}</td>
                        <td>{{ file.filename }}</td>
                        <td>{{ file.file_format || 'N/A' }}</td>
                        <td>{{file.xray_type ||'***'}}</td>
                        <td>{{ file.file_size_mb}}  </td>  
                        <td>
                            <div *ngIf="file.converted_s3_path">
                                <img [src]="file.converted_s3_path" 
                                     [alt]="file.filename" 
                                     class="img-thumbnail preview-image"
                                     style="max-width: 80px; max-height: 80px; cursor: pointer;"
                                     (click)="openImagePopup(file.converted_s3_path)" />
                            </div>
                            <div *ngIf="!file.converted_s3_path">
                                -
                            </div>
                        </td>                     
                    </tr>
            
                </tbody>

            </table>            
        </div>
        <!-- Image Popup Modal -->
        <div 
        class="image-popup-overlay" 
        *ngIf="selectedImageUrl"     
        >
            <div class="image-popup-content">
                <button class="close-btn" (click)="closeImagePopup()">×</button>
                <img [src]="selectedImageUrl" alt="Preview" class="popup-image">
            </div>
        </div>

                
           
       <div class="d-flex gap-3 p-3">
  <button class="btn btn-outline-info px-4" (click)="back()">戻る</button>
  <button class="btn btn-info" (click)="orderCreate()" *ngIf="customerData" [disabled]="loading"> 登録する</button>

</div>

          

            
    </div>
